import React from 'react'
import { Carousel } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../Header/Header';
import TopNavbar from '../TopNavbar'
import Footer from '../../Footer/Footer'
// import banner10 from '../img/banner 10.png'
import e320 from '../img/e320.jpg'
import E1 from '../img/KVPrasad.jpeg'
import e2 from '../img/MadanMohanRepala.jpeg'
import e3 from '../img/SatheeshKumarKode.jpeg'

function E320() {
  return (
    <div>
    <Header />
    <TopNavbar/>

    <div className="banner-area">
    <Carousel id="bootcarousel" className="text-light heading-uppercase animate_text" controls indicators={false}>
      {/* <Carousel.Item className="bg-cover img-fluid active">
        <img src={banner10} className="d-block w-100" alt="First slide" />
      </Carousel.Item> */}
      <Carousel.Item className="bg-cover img-fluid"  style={{padding:"30px"}}>
        <img src={e320} className="d-block w-100" alt="Second slide" />
      </Carousel.Item>
    </Carousel>
  </div>
<br></br>
<section id="about-us" className="about-us">
      <Container data-aos="fade-up">
        <div className="section-title">
          <h2>DG TEAM - DISTRICT 320E</h2>
        </div><br/>
        <Row style={{padding:"100px"}}>
          <Col lg={4} md={6} className="d-flex align-items-stretch">
            <div className="icon-box iconbox-blue">
              <div className="icon">
                <img src={e2} style={{ width:'200px',height:'200px' }} alt="Madan Mohan Repala" />
              </div>
              <h4>Madan Mohan Repala</h4>
              <p style={{color:"black"}}>District Governor<br/><br />Mobile: 98497 43345</p>
            </div>
          </Col>
          <Col lg={4} md={6} className="d-flex align-items-stretch">
            <div className="icon-box iconbox-blue">
              <div className="icon">
                <img src={E1} style={{ width:'200px',height:'200px' }} alt="K V Prasad" />
              </div>
              <h4>K V Prasad</h4>
              <p style={{color:"black"}}>First Vice District Governor<br/><br />Mobile: 98490 15066</p>
            </div>
          </Col>
          <Col lg={4} md={6} className="d-flex align-items-stretch">
            <div className="icon-box iconbox-blue">
              <div className="icon">
                <img src={e3} style={{ width: '200px',height:'200px' }} alt="Satheesh Kumar Kode" />
              </div>
              <h4>Satheesh Kumar Kode</h4>
              <p style={{color:"black"}}>Second Vice District Governor<br/><br />Mobile: 98480 82913</p>
            </div>
          </Col>
        </Row>
{/* 
        <div className="section-title">
          <h2>GALLERY - DISTRICT 320E</h2>
        </div> */}
        {/* <Row>
          <Col lg={4} md={6} className="d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div className="icon-box iconbox-blue">
              <div className="icon">
                <img src="https://lionsmd320.org/uploads/220705060757.jpg" style={{ width: '50%', cursor: 'zoom-in' }} alt="Installation ceremony" title="Installation ceremony" />
              </div>
              <span>Installation ceremony</span>
            </div>
          </Col>

         
        </Row> */}
      </Container>
    </section><br/>
    <Footer/> 
  </div>
  )
}

export default E320
